import { useAtomValue } from 'jotai';
import { getHtmlSignDocumentAtom } from '../../../store/global/atoms/documents-atoms/get-html-sign-document-atom';

export const useGetHtmlSignDocument = () => {
  const getHtmlSignDocument = useAtomValue(getHtmlSignDocumentAtom);

  return {
    htmlSignDocumentGetData: getHtmlSignDocument.data,
    getHtmlSignDocument: getHtmlSignDocument.mutate,
    getHtmlSignDocumentAsync: getHtmlSignDocument.mutateAsync,
    error: getHtmlSignDocument.error,
    isLoading: getHtmlSignDocument.isPending,
  };
};
